import React from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  MenuProps,
} from 'antd';

import {
  ConditionsReactivateFooterLinkDto,
  FooterLinkDto,
} from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalDesactivation from '../Modals/ModalDesactivation/ModalDesactivation';
import ModalReactivation from '../Modals/ModalReactivation/ModalReactivation';

import ConditionReactivateFooterLink from './ConditionReactivate/ConditionReactivateFooterLink';
import ModalDetails from './Modals/ModalDetails';
import ModalUpdate from './Modals/ModalUpdate';
import { useActivationFooterLink } from './utils/useActivation';

interface CellDetailsAndActionsProps {
  footerLink: FooterLinkDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  footerLink,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const modalDetails = useModal();
  const modalModification = useModal();
  const modalDeprecate = useModal();

  const { submitReactivate, submitDeprecate, conditionsReactivate } =
    useActivationFooterLink();

  const conditionUnlock = (
    conditions?: ConditionsReactivateFooterLinkDto,
  ): boolean => {
    return conditions?.reactivationAvailable ?? false;
  };

  const LABEL_DESACTIVATION = 'Désactiver le lien';
  const LABEL_REACTIVATION = 'Réactiver le lien';

  const items: MenuProps['items'] = [
    {
      key: 'modifier',
      label: 'Modifier',
      onClick: modalModification.open,
    },
    {
      key: 'desactiver',
      label: footerLink.valid ? LABEL_DESACTIVATION : LABEL_REACTIVATION,
      onClick: modalDeprecate.open,
    },
  ];

  return (
    <>
      <AntdButton onClick={modalDetails.open}>Détails</AntdButton>
      <ModalDetails
        footerLink={footerLink}
        visible={modalDetails.visible}
        close={modalDetails.close}
      />
      <AntdDropdown menu={{ items }} className="menuActions">
        <AntdButton>
          Actions <DownOutlined />
        </AntdButton>
      </AntdDropdown>
      <ModalUpdate
        refreshDashboard={refreshDashboard}
        footerLink={footerLink}
        visible={modalModification.visible}
        close={modalModification.close}
      />

      {footerLink.valid ? (
        <ModalDesactivation
          idCorrelation={footerLink.idCorrelation}
          titleModal={LABEL_DESACTIVATION}
          submitDeprecate={submitDeprecate}
          visible={modalDeprecate.visible}
          close={modalDeprecate.close}
          callAfterSubmit={refreshDashboard}
          componentUses={undefined}
          usesRequest={undefined}
        />
      ) : (
        <ModalReactivation
          idCorrelation={footerLink.idCorrelation}
          titleModal={LABEL_REACTIVATION}
          visible={modalDeprecate.visible}
          close={modalDeprecate.close}
          callAfterSubmit={refreshDashboard}
          conditionRequest={conditionsReactivate}
          componentConditions={ConditionReactivateFooterLink}
          conditionUnlock={conditionUnlock}
          reactivateRequest={submitReactivate}
        />
      )}
    </>
  );
}

export default CellDetailsAndActions;
